import * as z from "zod";

const sampleShipmentSchema_ = z.object({
  trackingNumber: z.string().nullable(),
  weightOz: z.number(),
  zone: z.string().nullable(),
  price: z.number(),
  merchantPaid: z.number().nullable(),
  currentRedoMargin: z.number().nullable(),
  date: z.string().nullable(),
  carrier: z.string().nullable(),
  serviceLevel: z.string().nullable(),
});
export type SampleShipment = z.infer<typeof sampleShipmentSchema_>;

const marginStatsSchema_ = z.object({
  min: z.number(),
  max: z.number(),
  avg: z.number(),
  median: z.number(),
  count: z.number(),
});

const cellSamplesSchema_ = z.object({
  samples: z.array(sampleShipmentSchema_),
  stats: z.object({
    min: z.number(),
    max: z.number(),
    avg: z.number(),
    median: z.number(),
    mode: z.number(),
    stdDev: z.number(),
  }),
  marginStats: marginStatsSchema_.nullable(),
});
export type CellSamples = z.infer<typeof cellSamplesSchema_>;

export const rateGridSchema = z.object({
  weightBucketsOz: z.array(z.number()),
  zones: z.array(z.string()),
  priceGrid: z.array(z.array(z.number().nullable())),
  countGrid: z.array(z.array(z.number())),
  sampleGrid: z.array(z.array(cellSamplesSchema_.nullable())).optional(),
});
export type RateGrid = z.infer<typeof rateGridSchema>;
